import ParseHTML from './ParseHTML';

export default ParseHTML;



// WEBPACK FOOTER //
// ./src/components/atoms/ParseHTML/index.js